import React from 'react';
import { Link } from 'react-router-dom';
import summerInternshipImage from '../images/summerinternship.jpeg';
import PhotoSlider from './PhotoSlider';
import photo1 from '../images/intership1/photo1.jpeg';
import photo2 from '../images/intership1/photo2.jpeg';
import photo3 from '../images/intership1/photo3.jpeg';
import photo4 from '../images/intership1/photo4.jpeg';
import photo5 from '../images/intership1/photo5.jpeg';
import photo6 from '../images/intership1/photo6.jpeg';
import photo7 from '../images/intership1/photo7.jpeg';
import photo8 from '../images/intership1/photo8.jpeg';
import photo9 from '../images/intership1/photo9.jpeg';
import photo10 from '../images/intership1/photo10.jpeg';
import photo11 from '../images/intership1/photo11.jpeg';
import photo12 from '../images/intership1/photo12.jpeg';



function SummerInternshipPage() {
  return (
    <section className="internship-page" aria-labelledby="summer-internship-heading">
      <div className="container internship-page-container">
        <Link className="internship-back-link" to="/#services">
          Back to Services
        </Link>

        <div className="internship-hero-card">
          <img
            src={summerInternshipImage}
            alt="Summer Internship Program 2026 participants"
            className="internship-hero-image"
            loading="lazy"
          />
          <div className="internship-hero-content">
            <p className="internship-kicker">Facilitated by Pratidhi Therapy & Wellness LLP</p>
            <h1 id="summer-internship-heading">Summer Internship Program 2026 Batch 1</h1>
            <p>
              During June-July 2026, Pratidhi Therapy & Wellness LLP successfully designed and facilitated a one-month online Summer Internship Program for psychology students and mental health enthusiasts seeking meaningful exposure to the field of psychology and counselling.
            </p>
            <p>
              The internship was developed to bridge the gap between academic learning and professional practice by providing participants with real-life, evidence-based insights into mental health work. The program emphasized experiential learning, practical skill development, and the application of psychological concepts in real-world contexts.
            </p>
          </div>
        </div>

        <div className="internship-photos-section">
          <h2 className="internship-photos-heading">Program Photos</h2>
          <PhotoSlider photos={[photo1, photo2, photo3, photo4, photo5, photo6, photo7, photo8, photo9, photo10, photo11, photo12]} />
        </div>

        <div className="internship-content-grid">
          <article className="internship-content-card">
            <h2>Program Highlights</h2>
            <ul>
              <li>1-Month Intensive Online Internship</li>
              <li>40-45 Hours of Structured Learning</li>
              <li>Live Interactive Sessions</li>
              <li>Real-Life Case Discussions</li>
              <li>Practical Activities and Reflection Exercises</li>
              <li>Skill-Based Assignments</li>
              <li>Final Presentation and Evaluation</li>
              <li>Certificate of Completion Provided</li>
            </ul>
          </article>

          <article className="internship-content-card">
            <h2>Key Areas Covered</h2>
            <ul>
              <li>Fundamentals of Counselling Skills</li>
              <li>Communication and Active Listening</li>
              <li>Emotional Wellbeing and Mental Health Awareness</li>
              <li>Psychological and Psychometric Assessments</li>
              <li>Ethics in Counselling and Mental Health Practice</li>
              <li>Case Conceptualization and Discussion</li>
              <li>Evidence-Based Approaches in Mental Health</li>
            </ul>
          </article>

          <article className="internship-content-card internship-content-card-wide">
            <h2>Learning Methodology</h2>
            <p>
              The internship incorporated a combination of lectures, experiential activities, role-plays, group discussions, practical assignments, assessment tasks, and real-life case discussions. Particular emphasis was placed on hands-on learning, ensuring that participants could actively engage with concepts rather than simply learning them theoretically.
            </p>
            <p>
              The activities and assignments were designed to be highly practical, encouraging participants to develop professional skills, critical thinking abilities, and a deeper understanding of psychological processes through application-based learning experiences.
            </p>
          </article>

          <article className="internship-content-card">
            <h2>Participant Profile</h2>
            <p>
              The program welcomed undergraduate and postgraduate students, as well as mental health enthusiasts interested in developing foundational knowledge and practical competencies within the field of psychology.
            </p>
          </article>

          <article className="internship-content-card internship-content-card-wide">
            <h2>Outcomes</h2>
            <p>
              Through this internship, participants gained exposure to real-life and evidence-based mental health practices, strengthened their counselling and communication skills, developed an understanding of ethical professional conduct, and enhanced their confidence in applying psychological concepts to practical situations.
            </p>
            <p>
              Upon successful completion of the internship requirements, participants were awarded a Certificate of Completion recognizing their commitment, engagement, and learning throughout the program.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}

export default SummerInternshipPage;
